import * as React from 'react'

import findIndex from 'lodash/findIndex'

import { observer } from 'mobx-react'

import createEffect from 'modules/core/hooks/createEffect'

import { usePlanningVersions } from 'modules/time_planning/store/collections/planningVersions'
import type PlanningVersion from 'modules/time_planning/store/models/PlanningVersion'

import Items from './Items'
import * as styles from './index.vanilla.css'

export interface Props {
  employeeId: number

  planningVersion: PlanningVersion
  canEditPlanningVersions: boolean
}

const useOffsetRecalculation = createEffect(
  (
    setLeft: React.Dispatch<React.SetStateAction<number>>,
    getLeftOffset: (index: number) => number,
    selectedIndex: number
  ) => {
    setLeft(getLeftOffset(selectedIndex))
  }
)

const Navigator = ({ employeeId, planningVersion, canEditPlanningVersions }: Props) => {
  const [left, setLeft] = React.useState(250)
  const rootEl = React.useRef<HTMLDivElement>(null)
  const planningVersions = usePlanningVersions()
  const sortedPlanningVersions = planningVersions.orderByEffectiveAt(employeeId)

  const selectedIndex = findIndex(
    sortedPlanningVersions,
    (item) => item.attributes.id === planningVersion.attributes.id
  )
  useOffsetRecalculation(setLeft, getLeftOffset, selectedIndex)

  function getLeftOffset(index: number): number {
    const el = rootEl.current

    if (!el) return 0

    return el.offsetWidth / 2 - 150 * index - 100
  }

  function onWheel(event: React.WheelEvent<HTMLDivElement>) {
    if (!event.deltaX) return

    const minLeft = getLeftOffset(0)
    const maxLeft = getLeftOffset(sortedPlanningVersions.length - 1)
    const value = left - event.deltaX
    setLeft(Math.min(Math.max(value, maxLeft), minLeft))
  }

  return (
    <div ref={rootEl} className={styles.root} onWheel={(event) => onWheel(event)}>
      <Items
        employeeId={employeeId}
        canEditPlanningVersions={canEditPlanningVersions}
        selectedPlanningVersion={planningVersion}
        left={left}
      />
    </div>
  )
}

export default observer(Navigator)
